export default __webpack_public_path__ + "static/media/image-cover.9a72adb8.png";